<template>
    <el-dialog
        class="invite-tabs"
        title="邀请入会"
        :visible.sync="dialogVisible"
        width="325px"
        height="260px"
        :before-close="handleClose"
        >
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="身份类型"  prop="mobilePhone">
                <el-select v-model="memberstypeValue" placeholder="请选择" @change="handleChange">
                    <el-option
                    v-for="item in memberstypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" :prop="memberstypeValue !== 'INVITATION_WATCHER' && memberstypeValue !== 'INVITATION_WATCHER2' ? 'name' : ''">
                <el-input v-model.trim="form.name" placeholder="请输入被邀请人姓名"></el-input>
            </el-form-item>
            <el-form-item label="" prop="mobilePhone">
                <el-input v-model.trim="form.mobilePhone" maxlength="11" placeholder="请输入被邀请人手机号"></el-input>
            </el-form-item>
            <el-form-item label="是否需要实名认证后参与">
                <el-radio-group v-model="form.needRealname"
                                style="width: 200px">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer invit-member">
            <el-button type="primary" @click="submitForm">确认</el-button>
        </span>
    </el-dialog>
</template>

<script>
import lodash from 'lodash'
import {inviteVisitors} from '@/api/meeting'
import {setStore, getStore} from '@/utils/utils'
export default {
    props: ['comdata'],
    data() {
        var validatePhone = (rule, value, callback) => {
            var myreg = /^1[3-9]\d{9}$/;
            if (value) {
                if (!myreg.test(value)) {
                    callback(new Error('手机号格式不正确'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        return {
            singleCaseId:0,
            singleMeetingId:0,
            form: {
                name: '',
                mobilePhone: '',
                needRealname: true,
            },
            dialogVisible: false,
            rules: {
                name: [
                    { required: true, message: '请输入被邀请人姓名', trigger: 'blur' },
                ],
                mobilePhone: [
                    { required: true, message: '请输入被邀请人手机号', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' }
                ]
            },
            memberstypeOptions: [{
                value: 'APPLICANT',
                label: '申请人'
            }, {
                value: 'APPLICANT_AGENT',
                label: '申请人代理人'
            }, {
                value: 'RESPONDENT',
                label: '被申请人'
            }, {
                value: 'RESPONDENT_AGENT',
                label: '被申请人代理人'
            },{
                value: 'INVITATION_WATCHER2',
                label: '仲裁员'
            },{
                value: 'LITIGANT_WITNESS',
                label: '证人'
            },{
                value: 'LITIGANT_THIRD',
                label: '第三人'
            },{
                value: 'OTHER',
                label: '其他人'
            }],
            memberstypeValue: ''
        }
    },
    watch: {
       
    },
    created() {
        let currentUserInfo = JSON.parse(getStore('loginInfo'))
    },
    mounted() {
    },
    methods: {
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    inviteVisitors({
                        caseId:this.singleCaseId,
                        meetingId:this.singleMeetingId,
                        meetingUserType: this.memberstypeValue,
                        name: this.form.name ? this.form.name : null,
                        phone:this.form.mobilePhone,
                        mediationMeetingType: 'MEDIATION_MEETING',
                        authStatus:this.form.needRealname?0:1
                    },this.comdata.invite).then(res => {
                        if (res.data.code === 1000) {
                            this.$message({
                                message: '邀请码已发送',
                                type: 'success'
                            });
                            this.dialogVisible = false
                        } else {
                            this.$message.error(res.data.message)
                        }
                    },erro => {
                        console.log(erro)
                    })
                } else {
                console.log('error submit!!');
                return false;
                }
            });
        },
        openAssistanceDialog(meetingID ,caseID) {
            this.form.mobilePhone = ''
            this.singleMeetingId = meetingID
            this.singleCaseId = caseID
            this.dialogVisible = true
        },
        inviteMediator(info) {
            /********邀请协助保存--选中的调解员*********/
            inviteMediator(info).then((res) => {
                this.dialogVisible = false
                if (res.data.code === 1000) {
                    this.$message({
                        message: `邀请码已发送给：${this.selectMediatorAlls}`,
                        type: 'success'
                    });
                    this.form.name = ''
                    this.$refs['form'].resetFields();
                    this.selectMediatorAll = ''
                    this.selectMediatorAlls = ''
                    this.checkedCities1 = []
                    this.$emit('afterInvite')
                } else {
                    this.$message.error(res.data.message);
                }
            }, (err) => {

            });
        },
        inviteMe() {
            if(this.isTemporary === 1) {
                /*******邀请临时调解*******/
                if(this.activeName !== 'first') {
                    if(this.inviteName === '' || !this.myreg.test(this.inviteName)) {
                        this.mediatorInfo = '请输入正确的11位手机号码'
                    } else {
                        this.saveTempMediator({
                            "caseMeetingId": this.caseMeetingId,
                            "mediatorInfo": this.inviteNameArrOther
                        })
                    }
                } else {
                    if(this.inviteNameArr.length > 0) {
                        this.saveTempMediator({
                                "caseMeetingId": this.caseMeetingId,
                                "mediatorInfo": this.inviteNameArr
                            })
                    }
                }
            } else {
                /*******邀请调解*******/
                if(this.inviteNameArr.length > 0) {
                    this.inviteMediator({
                            "caseId": Number(this.caseId),
                            "userList": this.checkedCities1
                        })
                }
            }
        },
        handleChange(value) {
            this.$refs['form'].resetFields();
        },
        handleClose(done) {
            this.dialogVisible = false
            setTimeout(() => {
                this.$refs['form'].resetFields();
                this.form.name = ''
            }, 1000);
        }
    }
}
</script>

<style lang="scss">
    .invite-tabs {
        .el-dialog{
            border-radius: 10px;
            .el-dialog__header {
                text-align: center;
                border-bottom: 1px solid #e6e5e5;
                .el-dialog__title {
                    color: #0083c8;
                    font-size: 18px;

                }
            }
            .el-dialog__footer{
                text-align: center;
                .invit-member{
                    display: inline-block;
                    .el-button--primary{
                        width: 280px;
                        height: 44px;
                    }
                }
            }
        }
        
    }
</style>
